module.exports = __webpack_public_path__ + "img/bg_function06_1_m.d72acc86.png";